export const themes = {
  dark: {
    id: 'dark',
    name: 'Dark',
    icon: 'fa-moon',
    colors: {
      // Backgrounds - Dark blue-gray
      bg: '#1a2028',
      bgSurface: '#1e2530',
      bgSurfaceLight: '#222a36',
      bgElevated: '#262e3b',
      bgOverlay: 'rgba(0, 0, 0, 0.75)',
      bgCard: 'rgba(255, 255, 255, 0.04)',
      bgInput: '#1e2530',
      bgHover: 'rgba(255, 255, 255, 0.06)',
      
      // Text - ALL WHITE
      text: '#ffffff',
      textWhite: '#ffffff',
      textSecondary: '#ffffff',
      textMuted: '#e2e8f0',
      textDim: '#cbd5e1',
      textInverse: '#ffffff',
      
      // Brand/Accent - #2e3642
      orange: '#2e3642',
      orangeDark: '#252c38',
      orangeLight: '#3d4756',
  // In dark theme - make accent backgrounds more visible
orangeBg: 'rgba(46, 54, 66, 0.55)',       // Was 0.4 - increased for visibility
orangeBgHover: 'rgba(46, 54, 66, 0.7)',    // Was 0.55 - increased
orangeBorder: 'rgba(46, 54, 66, 0.7)',     // Was 0.6 - increased
      orangeGlow: 'rgba(46, 54, 66, 0.35)',
      
      // Purple
      purple: '#8b5cf6',
      purpleLight: '#a78bfa',
      purpleBg: 'rgba(139, 92, 246, 0.12)',
      purpleBorder: 'rgba(139, 92, 246, 0.25)',
      
      // Green - Profit
      green: '#10b981',
      greenLight: '#34d399',
      greenDark: '#059669',
      greenBg: 'rgba(16, 185, 129, 0.12)',
      greenBorder: 'rgba(16, 185, 129, 0.25)',
      
      // Red - Loss
      red: '#ef4444',
      redLight: '#f87171',
      redDark: '#dc2626',
      redBg: 'rgba(239, 68, 68, 0.12)',
      redBorder: 'rgba(239, 68, 68, 0.25)',
      
      // Yellow
      yellow: '#f59e0b',
      yellowBg: 'rgba(245, 158, 11, 0.12)',
      yellowBorder: 'rgba(245, 158, 11, 0.25)',
      
      // Blue
      blue: '#3b82f6',
      blueBg: 'rgba(59, 130, 246, 0.12)',
      blueBorder: 'rgba(59, 130, 246, 0.25)',
      
      // Cyan
      cyan: '#22d3ee',
      cyanBg: 'rgba(34, 211, 238, 0.12)',
      cyanBorder: 'rgba(34, 211, 238, 0.25)',
      
      // Borders
      border: 'rgba(255, 255, 255, 0.06)',
      borderLight: 'rgba(255, 255, 255, 0.03)',
      borderMedium: 'rgba(255, 255, 255, 0.08)',
      borderStrong: 'rgba(255, 255, 255, 0.12)',
      borderHover: 'rgba(255, 255, 255, 0.16)',
      
      // Gradients
      gradientOrange: 'linear-gradient(to right, #2e3642, #3d4756)',
      gradientOrangePurple: 'linear-gradient(135deg, #2e3642, #3d4756, #8b5cf6)',
      gradientGreen: 'linear-gradient(to right, #10b981, #059669)',
      gradientRed: 'linear-gradient(to right, #ef4444, #dc2626)',
      
      // Shadows
      shadowOrange: '0 4px 16px rgba(46, 54, 66, 0.4)',
      shadowGlow: '0 0 20px rgba(46, 54, 66, 0.35)',
      shadowGreen: '0 0 20px rgba(16, 185, 129, 0.25)',
      shadowRed: '0 0 20px rgba(239, 68, 68, 0.25)',
      
      // Status
      statusConnected: '#10b981',
      statusDisconnected: '#ef4444',
      
      // Scrollbar
      scrollbarThumb: 'rgba(255, 255, 255, 0.12)',
      scrollbarThumbHover: 'rgba(255, 255, 255, 0.2)',
      scrollbarTrack: 'transparent',
      
      // Chart
      chartBg: '#1a2028',
      chartGrid: 'rgba(255, 255, 255, 0.03)',
      chartText: '#cbd5e1',
      chartBorder: 'rgba(255, 255, 255, 0.06)',
      chartCandleUp: '#10b981',
      chartCandleDown: '#ef4444',
      
      // Tags
      tagBronzeBg: 'rgba(205, 127, 50, 0.15)',
      tagBronzeText: '#cd7f32',
      tagBronzeBorder: 'rgba(205, 127, 50, 0.3)',
      tagSilverBg: 'rgba(192, 192, 192, 0.15)',
      tagSilverText: '#c0c0c0',
      tagSilverBorder: 'rgba(192, 192, 192, 0.3)',
      tagGoldBg: 'rgba(255, 215, 0, 0.15)',
      tagGoldText: '#ffd700',
      tagGoldBorder: 'rgba(255, 215, 0, 0.3)',
      tagDiamondBg: 'rgba(185, 242, 255, 0.15)',
      tagDiamondText: '#b9f2ff',
      tagDiamondBorder: 'rgba(185, 242, 255, 0.3)',
      tagPlatinumBg: 'rgba(229, 228, 226, 0.15)',
      tagPlatinumText: '#e5e4e2',
      tagPlatinumBorder: 'rgba(229, 228, 226, 0.3)',
      tagBlackBg: 'rgba(255, 255, 255, 0.15)',
      tagBlackText: '#ffffff',
      tagBlackBorder: 'rgba(255, 255, 255, 0.3)',
    },
    typography: {
      fontWeight: '400',
      fontWeightBold: '600',
      fontWeightExtrabold: '700',
      fontSize: '14px',
    },
  },

  light: {
    id: 'light',
    name: 'Light',
    icon: 'fa-sun',
    colors: {
      // Backgrounds - White matching Anzo Trade Landing
      bg: '#ffffff',
      bgSurface: '#f8fafc',
      bgSurfaceLight: '#f1f5f9',
      bgElevated: '#e2e8f0',
      bgOverlay: 'rgba(0, 0, 0, 0.4)',
      bgCard: '#f1f5f9',
      bgInput: '#f8fafc',
      bgHover: 'rgba(139, 92, 246, 0.05)',
      
      // Text - Black
      text: '#0f172a',
      textWhite: '#0f172a',
      textSecondary: '#334155',
      textMuted: '#475569',
      textDim: '#64748b',
      textInverse: '#ffffff',
      
      // Brand/Accent - Purple matching Anzo Trade
      orange: '#8b5cf6',
      orangeDark: '#7c3aed',
      orangeLight: '#a78bfa',
      orangeBg: 'rgba(139, 92, 246, 0.1)',
      orangeBgHover: 'rgba(139, 92, 246, 0.18)',
      orangeBorder: 'rgba(139, 92, 246, 0.35)',
      orangeGlow: 'rgba(139, 92, 246, 0.3)',
      
      // Purple
      purple: '#7c3aed',
      purpleLight: '#8b5cf6',
      purpleBg: 'rgba(124, 58, 237, 0.08)',
      purpleBorder: 'rgba(124, 58, 237, 0.22)',
      
      // Green - Profit
      green: '#059669',
      greenLight: '#10b981',
      greenDark: '#047857',
      greenBg: 'rgba(5, 150, 105, 0.1)',
      greenBorder: 'rgba(5, 150, 105, 0.22)',
      
      // Red - Loss
      red: '#dc2626',
      redLight: '#ef4444',
      redDark: '#b91c1c',
      redBg: 'rgba(220, 38, 38, 0.1)',
      redBorder: 'rgba(220, 38, 38, 0.22)',
      
      // Yellow
      yellow: '#d97706',
      yellowBg: 'rgba(217, 119, 6, 0.1)',
      yellowBorder: 'rgba(217, 119, 6, 0.22)',
      
      // Blue
      blue: '#3b82f6',
      blueBg: 'rgba(59, 130, 246, 0.1)',
      blueBorder: 'rgba(59, 130, 246, 0.22)',
      
      // Cyan
      cyan: '#0891b2',
      cyanBg: 'rgba(8, 145, 178, 0.1)',
      cyanBorder: 'rgba(8, 145, 178, 0.22)',
      
      // Borders
      border: '#e2e8f0',
      borderLight: '#f1f5f9',
      borderMedium: '#cbd5e1',
      borderStrong: '#94a3b8',
      borderHover: '#64748b',
      
      // Gradients - Purple matching Anzo Trade buttons
      gradientOrange: 'linear-gradient(to right, #7c3aed, #8b5cf6, #6366f1)',
      gradientOrangePurple: 'linear-gradient(135deg, #7c3aed, #8b5cf6, #6366f1)',
      gradientGreen: 'linear-gradient(to right, #10b981, #059669)',
      gradientRed: 'linear-gradient(to right, #ef4444, #dc2626)',
      
      // Shadows
      shadowOrange: '0 4px 20px rgba(139, 92, 246, 0.3)',
      shadowGlow: '0 0 24px rgba(139, 92, 246, 0.25)',
      shadowGreen: '0 0 20px rgba(16, 185, 129, 0.2)',
      shadowRed: '0 0 20px rgba(239, 68, 68, 0.2)',
      
      // Status
      statusConnected: '#059669',
      statusDisconnected: '#dc2626',
      
      // Scrollbar
      scrollbarThumb: 'rgba(139, 92, 246, 0.25)',
      scrollbarThumbHover: 'rgba(139, 92, 246, 0.45)',
      scrollbarTrack: '#f1f5f9',
      
      // Chart
      chartBg: '#ffffff',
      chartGrid: 'rgba(0, 0, 0, 0.06)',
      chartText: '#64748b',
      chartBorder: 'rgba(0, 0, 0, 0.08)',
      chartCandleUp: '#059669',
      chartCandleDown: '#dc2626',
      
      // Tags
      tagBronzeBg: 'rgba(205, 127, 50, 0.12)',
      tagBronzeText: '#b8731f',
      tagBronzeBorder: 'rgba(205, 127, 50, 0.3)',
      tagSilverBg: 'rgba(140, 140, 140, 0.12)',
      tagSilverText: '#6b6b6b',
      tagSilverBorder: 'rgba(140, 140, 140, 0.3)',
      tagGoldBg: 'rgba(200, 160, 0, 0.12)',
      tagGoldText: '#b8960f',
      tagGoldBorder: 'rgba(200, 160, 0, 0.3)',
      tagDiamondBg: 'rgba(100, 180, 220, 0.12)',
      tagDiamondText: '#3b8bbf',
      tagDiamondBorder: 'rgba(100, 180, 220, 0.3)',
      tagPlatinumBg: 'rgba(140, 140, 150, 0.12)',
      tagPlatinumText: '#5c5c6e',
      tagPlatinumBorder: 'rgba(140, 140, 150, 0.3)',
      tagBlackBg: 'rgba(0, 0, 0, 0.1)',
      tagBlackText: '#1a1a1a',
      tagBlackBorder: 'rgba(0, 0, 0, 0.25)',
    },
    typography: {
      fontWeight: '500',
      fontWeightBold: '700',
      fontWeightExtrabold: '800',
      fontSize: '14px',
    },
  },
};

// Map theme colors to CSS custom properties
export const getThemeCSSVariables = (theme) => {
  const colors = theme.colors;
  const typography = theme.typography;
  
  return {
    '--color-bg': colors.bg,
    '--color-bgSurface': colors.bgSurface,
    '--color-bgSurfaceLight': colors.bgSurfaceLight,
    '--color-bgElevated': colors.bgElevated,
    '--color-bgOverlay': colors.bgOverlay,
    '--color-bgCard': colors.bgCard,
    '--color-bgInput': colors.bgInput,
    '--color-bgHover': colors.bgHover,
    
    '--color-text': colors.text,
    '--color-textWhite': colors.textWhite,
    '--color-textSecondary': colors.textSecondary,
    '--color-textMuted': colors.textMuted,
    '--color-textDim': colors.textDim,
    '--color-textInverse': colors.textInverse,
    
    '--color-orange': colors.orange,
    '--color-orangeDark': colors.orangeDark,
    '--color-orangeLight': colors.orangeLight,
    '--color-orangeBg': colors.orangeBg,
    '--color-orangeBgHover': colors.orangeBgHover,
    '--color-orangeBorder': colors.orangeBorder,
    '--color-orangeGlow': colors.orangeGlow,
    
    '--color-purple': colors.purple,
    '--color-purpleLight': colors.purpleLight,
    '--color-purpleBg': colors.purpleBg,
    '--color-purpleBorder': colors.purpleBorder,
    
    '--color-green': colors.green,
    '--color-greenLight': colors.greenLight,
    '--color-greenDark': colors.greenDark,
    '--color-greenBg': colors.greenBg,
    '--color-greenBorder': colors.greenBorder,
    
    '--color-red': colors.red,
    '--color-redLight': colors.redLight,
    '--color-redDark': colors.redDark,
    '--color-redBg': colors.redBg,
    '--color-redBorder': colors.redBorder,
    
    '--color-yellow': colors.yellow,
    '--color-yellowBg': colors.yellowBg,
    '--color-yellowBorder': colors.yellowBorder,
    
    '--color-blue': colors.blue,
    '--color-blueBg': colors.blueBg,
    '--color-blueBorder': colors.blueBorder,
    
    '--color-cyan': colors.cyan,
    '--color-cyanBg': colors.cyanBg,
    '--color-cyanBorder': colors.cyanBorder,
    
    '--color-border': colors.border,
    '--color-borderLight': colors.borderLight,
    '--color-borderMedium': colors.borderMedium,
    '--color-borderStrong': colors.borderStrong,
    '--color-borderHover': colors.borderHover,
    
    '--color-gradientOrange': colors.gradientOrange,
    '--color-gradientOrangePurple': colors.gradientOrangePurple,
    '--color-gradientGreen': colors.gradientGreen,
    '--color-gradientRed': colors.gradientRed,
    
    '--color-shadowOrange': colors.shadowOrange,
    '--color-shadowGlow': colors.shadowGlow,
    '--color-shadowGreen': colors.shadowGreen,
    '--color-shadowRed': colors.shadowRed,
    
    '--color-statusConnected': colors.statusConnected,
    '--color-statusDisconnected': colors.statusDisconnected,
    
    '--color-scrollbarThumb': colors.scrollbarThumb,
    '--color-scrollbarThumbHover': colors.scrollbarThumbHover,
    '--color-scrollbarTrack': colors.scrollbarTrack,
    
    '--color-chartBg': colors.chartBg,
    '--color-chartGrid': colors.chartGrid,
    '--color-chartText': colors.chartText,
    '--color-chartBorder': colors.chartBorder,
    '--color-chartCandleUp': colors.chartCandleUp,
    '--color-chartCandleDown': colors.chartCandleDown,
    
    // Tags
    '--color-tagBronzeBg': colors.tagBronzeBg,
    '--color-tagBronzeText': colors.tagBronzeText,
    '--color-tagBronzeBorder': colors.tagBronzeBorder,
    '--color-tagSilverBg': colors.tagSilverBg,
    '--color-tagSilverText': colors.tagSilverText,
    '--color-tagSilverBorder': colors.tagSilverBorder,
    '--color-tagGoldBg': colors.tagGoldBg,
    '--color-tagGoldText': colors.tagGoldText,
    '--color-tagGoldBorder': colors.tagGoldBorder,
    '--color-tagDiamondBg': colors.tagDiamondBg,
    '--color-tagDiamondText': colors.tagDiamondText,
    '--color-tagDiamondBorder': colors.tagDiamondBorder,
    '--color-tagPlatinumBg': colors.tagPlatinumBg,
    '--color-tagPlatinumText': colors.tagPlatinumText,
    '--color-tagPlatinumBorder': colors.tagPlatinumBorder,
    '--color-tagBlackBg': colors.tagBlackBg,
    '--color-tagBlackText': colors.tagBlackText,
    '--color-tagBlackBorder': colors.tagBlackBorder,
    
    '--font-weight': typography.fontWeight,
    '--font-weightBold': typography.fontWeightBold,
    '--font-weightExtrabold': typography.fontWeightExtrabold,
    '--font-size': typography.fontSize,
  };
};